import type { IConfig } from '../../types';

export const config: IConfig = {
  component: 'ChildContainer',
  configGroups: [],
};
